import * as types from './types';
import {
  ToolBookCollectionStatementListModel,//学生领书申请列表
  ToolBookCollectionStatementPassRejectModel,//领书申请通过驳回
  ToolBookCollectionStatementListDetailModel,//领书申请教材详情列表
} from 'src/model/AdminModel';

export default{
  //学生领书申请列表
  actionBookCollectionStatementList({state,commit},query){
    commit(types.ACTION_BOOK_COLLECTION_STATEMENT_LIST, {
      state: 'loading'
    });
    return ToolBookCollectionStatementListModel.getInstance().execute(query).then((response) => {
      commit(types.ACTION_BOOK_COLLECTION_STATEMENT_LIST, {
        ...response,
        state: 'loadend',
        'list': response.list
      });
      return response;
    }).catch((err) => {
      commit(types.ACTION_BOOK_COLLECTION_STATEMENT_LIST, {
        state: 'loaderr'
      });
      return Promise.reject(err);
    });
  },

  //领书申请教材详情列表
  actionBookCollectionDetailStatementList({state,commit},query){
    commit(types.ACTION_BOOK_COLLECTION_DETAIL_STATEMENT_LIST, {
      state: 'loading'
    });
    return ToolBookCollectionStatementListDetailModel.getInstance().execute(query).then((response) => {
      commit(types.ACTION_BOOK_COLLECTION_DETAIL_STATEMENT_LIST, {
        data:{
          list:[...response],
          state: 'loadend',
        },
      });
      return response;
    }).catch((err) => {
      commit(types.ACTION_BOOK_COLLECTION_DETAIL_STATEMENT_LIST, {
        state: 'loaderr'
      });
      return Promise.reject(err);
    });
  },

  //领书申请通过驳回
  actionBookCollectionStatementPassReject({state,commit},query){
    return ToolBookCollectionStatementPassRejectModel.getInstance().execute(query)
  },
}



// WEBPACK FOOTER //
// ./src/store/Admin/modules/bookCollection/actions.js